import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ReorderGlyph = /*#__PURE__*/createElement("g", {
  id: "reorder"
}, /*#__PURE__*/createElement("path", {
  d: "M60.5 49.6h-37c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h37c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM60.5 37.4h-37c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h37c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}));
const Reorder = createSvg({
  name: 'reorder',
  path: ReorderGlyph
});

export default Reorder;
export { ReorderGlyph };
